import { assertNotEmpty } from '@festina-life/core'
import {
  RawCheckbox,
  RawSelect,
  RawTextArea,
  RawTextInput,
} from '@festina-life/ui/forms'

import type { LiteralTypeInformation } from '../../fplusExpression/types'

export const FPlusSingleLiteralEditor = ({
  typeInformation,
  currentValue,
  onChange,
}: {
  currentValue: string
  onChange: (nextValue: string) => void
  typeInformation: LiteralTypeInformation
}) => {
  switch (typeInformation.literalType) {
    case 'string': {
      const valueWithoutQuotes = currentValue.substring(
        1,
        currentValue.length - 1,
      )

      return (
        <RawTextArea
          value={valueWithoutQuotes}
          onClick={(evt) => evt.stopPropagation()}
          onChange={(evt) => onChange(`"${evt.target.value}"`)}
          autoFocus
        />
      )
    }
    case 'boolean':
      return (
        <RawCheckbox
          checked={currentValue === 'true'}
          onClick={(evt) => evt.stopPropagation()}
          onChange={(checked) => onChange(checked ? 'true' : 'false')}
        />
      )
    case 'enum': {
      assertNotEmpty(typeInformation.enumOptions)

      return (
        <RawSelect
          onClick={(evt) => evt.stopPropagation()}
          options={typeInformation.enumOptions}
          onChange={(nextOption) => onChange(nextOption ?? '')}
          value={currentValue}
        />
      )
    }
    case 'integer':
    case 'fraction':
    case 'blank':
    case 'null':
    case undefined:
    case null:
    default:
      return (
        <RawTextInput
          onClick={(evt) => evt.stopPropagation()}
          value={currentValue}
          onChange={(evt) => onChange(evt.target.value)}
          autoFocus
        />
      )
  }
}
